function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Total Blocks");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Iconography-/-Total-Blocks",
  fill: "#063C4F",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M32,16 L32,48 L0,48 L0,16 L32,16 Z M29,19 L3,19 L3,45 L29,45 L29,19 Z M40,8 L40,40 L36.952381,40 L36.952381,11.047619 L8,11.047619 L8,8 L40,8 Z M23,25 L23,39 L20.0527284,39 L20.0527284,30.031227 L11.1465146,38.9374409 L9.06255914,36.8531174 L17.968773,27.9472716 L9,27.9472716 L9,25 L23,25 Z M48,0 L48,32 L44.952381,32 L44.952381,3.04761905 L16,3.04761905 L16,0 L48,0 Z",
  id: "Total-Blocks"
})));

var SvgTotalBlocks = function SvgTotalBlocks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTotalBlocks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TotalBlocks.59c92683.svg";
export { ForwardRef as ReactComponent };